import React, { FC, useEffect, useState } from 'react';
import { ApiKey } from './ApiKey';
import { TokenizationPage } from './TokenizationPage';
import { fetchWebhooksList } from '../../api/webhook-api-service';
import { checkRoles, CLAIMS } from '../../utils/roles-helper';
import { HmacSigningKey } from '../../components/developers/HmacSigningKey';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { useTranslation } from 'react-i18next';
import { useParams, useLocation } from 'react-router-dom';

export const ApiKeysPage: FC = () => {
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const { t } = useTranslation();
	const { id: mid, partnerId } = useParams();
	const { pathname } = useLocation();

	const [loading, setLoading] = useState(false);
	const [subscriberKey, setSubscriberKey] = useState<string>('-');

	const refetchData = async (): Promise<void> => {
		setLoading(true);

		const data = await fetchWebhooksList(mid, partnerId);

		if (data?.length && data?.[0]?.subscriberKey) {
			setSubscriberKey(data?.[0]?.subscriberKey);
		}
		setLoading(false);
	};

	useEffect(() => {
		if (checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN)) {
			void refetchData();
		}
	}, []);

	const csvData = [
		[t('WEBHOOKS.SUBSCRIBER_KEY'), subscriberKey]
	];

	return (
		<>
			<ApiKey/>
			<TokenizationPage/>
			{
				checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN) && (
					<HmacSigningKey
						subscriberKey={subscriberKey}
						loading={loading}
						csvData={subscriberKey && subscriberKey !== '-' && csvData}
					/>
				)
			}
		</>
	);
};
